export enum ScreeningResultsTypes {
  Approved = 'Approved',
  ApprovedWithConditions = 'Approved with Conditions',
  Denied = 'Denied',
}
